import { Action } from '@ngrx/store';
import { AttentionPlace } from '@models/attention-place.model';
import { UserInstallation, UserInstallationResponse } from '@models/installation.model';

export const UPLOADINSTALLATIONUSERS = '[Installation] Cargar usuario instalacion';

export const SELECTATTENTIONPLACE = '[Installation] Seleccionar lugar atencion';

export const DELETEINSTALLATIONDATA = '[Installation] Borrar datos instalacion';

export class UploadInstallationUsers implements Action {
    readonly type = UPLOADINSTALLATIONUSERS;

    constructor(public installationUsersResponse: UserInstallationResponse | null) {}
  }

export class SelectAttentionPlace implements Action {
  readonly type = SELECTATTENTIONPLACE;

  constructor(public attentionPlace: AttentionPlace | null) {}
}

export class DeleteInstallationData implements Action {
  readonly type = DELETEINSTALLATIONDATA;
}

export type InstallationActions =
  | UploadInstallationUsers
  | SelectAttentionPlace
  | DeleteInstallationData;
